module.exports = __webpack_public_path__ + "img/1723597576957-image.jpg.1ca0ec04.webp";